module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1189.ae72c82e.png";